export interface Caregiver {
	id: number;
	patientId: number;
	name: string;
	email: string;
	phone: string;
	relationship: Relationship;
	purposeOfInvolvement: PurposeOfInvolvement[];
	sendHealthSummaryReport: boolean;
	deleted: boolean;
	createdOn: string; // Date
	updatedOn: string; // Date
	deletedOn: string; // Date
}

export enum PurposeOfInvolvement {
	AppointmentReminders = "AppointmentReminders",
	CoachingCalls = "CoachingCalls",
	ShareHealthInformation = "ShareHealthInformation",
	All = "All",
}

export enum Relationship {
	SONORDAUGHTER = "SonOrDaughter",
	PARENT = "Parent",
	SIBLING = "Sibling",
	SPOUSE = "Spouse",
	FRIEND = "Friend",
	ROOMMATE = "Roommate",
	OTHER = "Other",
}

export type RelationshipKey = keyof typeof Relationship;

/**
 * Maps a stored relationship string onto the canonical vocabulary the UI has
 * translations for. CHILD is son/daughter; anything off-vocabulary is Other. KAN-2469.
 */
export const normalizeRelationship = (
	relationship: string | null | undefined
): RelationshipKey | null => {
	if (!relationship) return null;
	const normalized = relationship.trim().toUpperCase();
	if (!normalized) return null;
	if (normalized === "CHILD") return "SONORDAUGHTER";
	return (normalized in Relationship ? normalized : "OTHER") as RelationshipKey;
};
